import { CaptionedImage } from '@/components/controls';
import { useNichePersonImage, useOptionLookup } from '@/hooks';

export function UrgentActionPerson({ person }) {
  const personClassifications = useOptionLookup('personClassification');
  const { data: imageSrc } = useNichePersonImage(person.id);

  return (
    <CaptionedImage
      imageSrc={imageSrc}
      height={320}
      fallbackWidth={240}
      topCaption={(person.classificationCodes ?? [])
        .map((code) => personClassifications[code] ?? code)
        .join(', ')}
      bottomCaption={[person.forenames, person.surname].join(' ').toLowerCase()}
      bottomCaptionProps={{ sx: { textTransform: 'capitalize' } }}
    />
  );
}
